module.exports = __webpack_public_path__ + "hero-expertise-right.3YQPrPFF.png";